'use strict';

var AdvancedProfileChartDirective = function AdvancedProfileChartDirective(Chart) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/advanced-profile-chart.html'),
    controller: 'AdvancedProfileChartController',
    scope: true,
    link: function link(scope, element) {
      var chartElement = element.find('.chart-container');
      var chart = new Chart(chartElement, scope.chartFormatters);
      scope.renderChartDataPresent = function (data) {
        chart.withMetric(scope.contextData.selectedMetric.label).render(data);
      };
    }
  };
};
AdvancedProfileChartDirective.$inject = ['AdvancedProfileChart'];
module.exports = AdvancedProfileChartDirective;